import { Component, Input, OnInit } from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-auto-logout',
    templateUrl: './auto-logout.component.html',
    imports: [
        CommonModule
    ]
})
export class AutoLogoutComponent implements OnInit {

    constructor() { }

    ngOnInit() {

    }

    @Input() public logOut: () => void;
    @Input() public remainSignedIn: () => void;

    ngAfterViewInit() {
        
    }

    ngOnDestroy() {
        
    }
}
